import KitResource from "../../resources/kit-resource"

export const makeKitResource = (): KitResource => {
    return new KitResource()
}
